<template>
    <div class="container mt-4">
        <h4 class="page-title">İletişim</h4>
        <div>
            <div class="jumbotron">
                <div class="content-page">
                    <p>Bilet işlemleriniz konusunda hafta içi her gün 09:00-18:00 saatlerinde destek alabileceğiniz çağrı
                        merkezimiz ile daima yanınızdayız. Tüm iptal, değişiklik, iade vb. sorunlarınıza cevap verebilmek
                        için alanında uzman ekibimiz ile size bir telefon kadar yakınız.</p>
                </div>
            </div>
            <h4 class="page-title">Bizi Arayın</h4>
            <div class="jumbotron">
                <div class="content-page">
                    <div class="map-wrap clearfix"> <div>
                        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1898.3149628936628!2d30.750899065438986!3d36.85271334848787!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14c3901a17646ee3%3A0xfac105b6828edac!2sBiletBul.Com+%7C+Ucuz+U%C3%A7ak+Bileti+Bul!5e0!3m2!1str!2s!4v1436430750670"
                                width="100%" height="370" frameborder="0" style="border:0" allowfullscreen=""></iframe>
                    </div>
                    </div>

                        <img src="../assets/images/map.png" style="width: 14px;
    margin-bottom: 7px;">
                        <span style="font-size: 16px"> Fener Mh. Tekelioğlu Cd. Sema Apt. No:54/A Muratpaşa - ANTALYA</span>

                    <br />
                    <img src="../assets/images/phone.png"
                         style="width: 20px;margin-bottom: 3px;">
                    <span style="font-size: 16px"> +90 (242) 323 23 00 </span>
                    <br />
                    <img src="../assets/images/mail.png"
                         style="width: 16px;margin-bottom: 3px;">
                    <span style="font-size: 16px"> bilal@biletbul.com</span>
                    <br>
                </div>
            </div>
            <h4 class="page-title">Bize Yazın</h4>
            <div class="jumbotron">
                <div class="content-page">
                    <p> Sorularınız veya görüşleriniz için lütfen aşağıdaki formu doldurun: </p>
                    <form class="needs-validation" novalidate @submit.prevent="submitForm">
                        <mdb-row>
                            <mdb-col md="12">
                                <mdb-row>
                                    <mdb-col>
                                        <div class="form-group">
                                            <label for="adiniz">Adınız</label>
                                            <input type="text" id="adiniz" class="form-control" v-model="fields.name">
                                        </div>
                                    </mdb-col>
                                    <mdb-col>
                                        <div class="form-group">
                                            <label for="soyadiniz">Soyadınız</label>
                                            <input type="text" id="soyadiniz" class="form-control" v-model="fields.surename">
                                        </div>
                                    </mdb-col>
                                </mdb-row>
                                <mdb-row>
                                    <mdb-col>
                                        <div class="form-group">
                                            <label for="telefon">Telefon</label>
                                            <input type="text" id="telefon" class="form-control" v-model="fields.phone">
                                        </div>
                                    </mdb-col>
                                    <mdb-col>
                                        <div class="form-group">
                                            <label for="eposta">Eposta</label>
                                            <input type="email" id="eposta" class="form-control" v-model="fields.email">
                                        </div>
                                    </mdb-col>

                                </mdb-row>
                                <mdb-row>
                                    <mdb-col>
                                        <label class="pb-0">Mesajınız</label>
                                        <mdb-input class="mt-0" outline style="background-color: white;color: black"
                                                type="textarea"
                                                label=""
                                                v-model="fields.message"
                                                required
                                        />
                                    </mdb-col>
                                </mdb-row>
                            </mdb-col>

                        </mdb-row>
                        <mdb-btn color="" type="button" size="sm" style="background-color: white;border:1px solid #3399d4">Temizle</mdb-btn>
                        <mdb-btn color="" type="submit" size="sm" class="float-right" style="background-color: white;border:1px solid #3399d4" >Gönder</mdb-btn>
                    </form>
                </div>
            </div>
            <h4 class="page-title">İletişim</h4>
            <div class="jumbotron">
                <div class="content-page">
                    <p> Canlı destek bölümümüzden hafta içi her gün 09:00-18:00 saatlerinde ulaşabilirisiniz. </p>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        mdbContainer,
        mdbInput,
        mdbCard,
        mdbCardHeader,
        mdbCardTitle,
        mdbCardText,
        mdbCardBody,
        mdbIcon,
        mdbBtn,
        mdbRow,
        mdbCol
    } from "mdbvue";
    export default {
        name: "contactPage.vue",
        data () {
            return {
                title : 'İletişim',
                fields: {
                    name: "",
                    email: "",
                    subject: "",
                    message: ""
                }
            }
        },
        components: {
            mdbContainer,
            mdbInput,
            mdbCard,
            mdbCardHeader,
            mdbCardTitle,
            mdbCardBody,
            mdbCardText,
            mdbIcon,
            mdbBtn,
            mdbRow,
            mdbCol
        }
    }
</script>

<style scoped>
    .jumbotron {
        border-radius: 6px;
        border: 1px solid #bbb;
        background-color: #ebeef1;
        box-shadow: none;
        padding: 0.5rem 1rem;
    }
    p {
        margin-bottom: 0;
    }
</style>
